var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2929 5.51764C19.6834 5.12711 19.6834 4.49395 19.2929 4.10342L16.7299 1.54044C16.3394 1.14991 15.7062 1.14991 15.3157 1.54044L10.7071 6.14902C10.3166 6.53955 9.68342 6.53955 9.29289 6.14903L4.68431 1.54044C4.29378 1.14991 3.66062 1.14991 3.27009 1.54044L0.707107 4.10342C0.316583 4.49395 0.316582 5.12711 0.707107 5.51763L5.3157 10.1262C5.70622 10.5167 5.70622 11.1499 5.3157 11.5404L0.707107 16.149C0.316583 16.5395 0.316583 17.1727 0.707107 17.5632L3.27009 20.1262C3.66061 20.5167 4.29378 20.5167 4.6843 20.1262L9.29289 15.5176C9.68342 15.1271 10.3166 15.1271 10.7071 15.5176L15.3157 20.1262C15.7062 20.5167 16.3394 20.5167 16.7299 20.1262L19.2929 17.5632C19.6834 17.1727 19.6834 16.5395 19.2929 16.149L14.6843 11.5404C14.2938 11.1499 14.2938 10.5167 14.6843 10.1262L19.2929 5.51764Z",
    fill: "url(#paint0_linear_3549_42205)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3549_42205",
    x1: 2.85,
    y1: 28.8333,
    x2: 32.7465,
    y2: 1.53115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIcon);
export default __webpack_public_path__ + "static/media/no-icon.4732a54978f7e506fcf7b2289d948f03.svg";
export { ForwardRef as ReactComponent };